import { colors, screen } from 'components/styles/variables';

interface FeatureGroupViewModel {
  icon: string;
  title: string;
  features: string[];
}

interface FeatureGroupProps extends FeatureGroupViewModel {
  twoColumns?: boolean;
  className?: string;
}

const FeatureGroup = ({
  icon,
  title,
  features,
  className = '',
  twoColumns = false,
}: FeatureGroupProps): JSX.Element => {
  const featureClassName = twoColumns ? 'two-columns' : '';
  return (
    <div className={`feature-group ${className}`}>
      <div className="icon" />
      <div className="feature-container">
        <div className="title">{title}</div>
        <ul className={`feature-list ${featureClassName}`} data-testid="feature-list">
          {features.map((feature, idx) => (
            <li className="feature-list-item" key={idx}>
              {feature}
            </li>
          ))}
        </ul>
      </div>
      <style jsx>{`
        .feature-group {
          display: flex;
        }

        .icon {
          display: none;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .icon {
            display: block;
            width: 44px;
            height: 44px;
            margin-right: 16px;
            flex-shrink: 0;
            background-image: url(${icon});
            background-size: cover;
          }
        }

        .title {
          margin: 0px 0px 8px 0px;
          color: ${colors.BLACK};
          font-size: 16px;
          font-weight: 700;
          text-transform: uppercase;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .title {
            margin: 10px 0px;
            font-size: 18px;
          }
        }

        .feature-container {
          flex-grow: 1;
        }

        .feature-list {
          line-height: 1.7;
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .feature-list .feature-list-item {
          font-size: 16px;
          font-weight: 300;
          color: ${colors.BLACK};
        }

        @media screen and (min-width: ${screen.smMin}) {
          .feature-list .feature-list-item {
            font-size: 18px;
          }
        }

        .two-columns {
          display: flex;
          flex-flow: row wrap;
        }

        .two-columns .feature-list-item {
          width: 100%;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .two-columns .feature-list-item {
            width: 50%;
          }
        }
      `}</style>
    </div>
  );
};

export default FeatureGroup;
